import { Base } from '@studiometa/js-toolkit';

/**
 * Class ImageZoom
 *key @extends Base
 */
export default class ImageZoom extends Base {
  static config = {
    name: 'ImageZoom',
    refs: ['picture'],
  };

  /**
   *
   * @param {*} progress
   */
  moved({ progress }) {
    if (!this.$parent.isOpen) {
      return;
    }

    if (this.$refs.picture.className === 'landscape') {
      this.$refs.picture.style.transform = `translate3D(calc(${progress.x} * (-100% + 100vw)), 0, 0)`;
    } else {
      this.$refs.picture.style.transform = `translate3D(0, calc(${progress.y} * (-100% + 100vh)), 0)`;
    }
  }
}
